import { useMutation } from '@tanstack/react-query';

import createRestClient from '@/shared/api/restClient';
import { type EntityType } from '~/common/enums';

type PersistDocumentRequest = {
  documentIds: string[];
  entityId: string;
  entityType: EntityType;
  parentEntityId: string;
};

const client = createRestClient();

const usePersistBatchDocuments = () => {
  const { mutate, mutateAsync, isLoading } = useMutation(async (req: PersistDocumentRequest) =>
    client.put('/document/attachments/persist', req),
  );

  return {
    isUpdatingDocumentsPersistence: isLoading,
    updateDocumentsPersistence: mutate,
    updateDocumentsPersistenceAsync: mutateAsync,
  };
};

export default usePersistBatchDocuments;
